export const getSuccessfulQualificationChangeMessage = (newQualification: string) =>
  `Your preferred qualification is updated to  ${newQualification} to view these shifts`;

export const getUnsuccessfulQualificationChangeMessage = (newQualification: string) =>
  `Failed to update your preferred qualification to ${newQualification} in order to view these shifts`;
